/*!
VueLayers
Vue 2 components to work with OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.9.1
@license MIT
@copyright (c) 2017-2018, Vladimir Vershinin <ghettovoice@gmail.com>
*/
import ImageStaticSource from 'ol/source/imagestatic';
import { imageSource, withUrl } from '../core';

/** @module image-static-source/source */
/**
 * @vueProps
 */
var props = /** @lends module:image-static-source/source# */{
  /**
   * Image extent in the source projection.
   * @type {ol.Extent|number[]}
   */
  extent: {
    type: Array,
    required: true,
    validator: function validator(value) {
      return value.length === 4;
    }
  },
  /**
   * Optional function to load an image given a URL.
   * @type {function|undefined}
   */
  loadFunc: Function,
  /**
   * Image size in pixels.
   * @type {ol.Size|number[]}
   */
  size: {
    type: Array,
    validator: function validator(value) {
      return value.length === 2;
    }
  },
  /**
   * Image URL.
   * @type {string}
   */
  url: {
    type: String,
    required: true,
    validator: function validator(value) {
      return !!value.length;
    }
  }

  /**
   * @vueMethods
   */
};var methods = /** @lends module:image-static-source/source# */{
  /**
   * @return {ol.source.ImageStatic}
   * @protected
   */
  createSource: function createSource() {
    return new ImageStaticSource({
      attributions: this.attributions,
      crossOrigin: this.crossOrigin,
      imageExtent: this.extent,
      imageLoadFunction: this.loadFunc,
      logo: this.logo,
      projection: this.projection,
      imageSize: this.size,
      url: this.urlTmpl
    });
  }
};

/**
 * A layer source for displaying a single, static image.
 *
 * @vueProto
 * @title vl-source-image-static
 * @alias module:image-static-source/source
 */
var Source = {
  name: 'vl-source-image-static',
  mixins: [imageSource, withUrl],
  props: props,
  methods: methods
};

/** @module image-static-source */
/**
 * @alias module:image-static-source
 */
var index = {
  /**
   * A layer source for displaying a single, static image.
   * @alias module:image-static-source/source
   */
  Source: Source,
  install: function install(Vue) {
    Vue.component(Source.name, Source);
  }
};

export default index;

//# sourceMappingURL=index.es.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/vuelayers/lib/image-static-source/index.es.js
// module id = null
// module chunks = 